import { useState, useEffect, useReducer, useRef } from "react";
import "./crps.css";
import { RequiredRule } from "devextreme-react/validator";
import ScrollView from "devextreme-react/scroll-view";

import * as action from "../../actions/rps";
import rpsReducer from "../../reducers/rps";
import "../../styles/scss/gallery.scss";
import { Button } from "devextreme-react/button";
import {
  CONFIG,
  sizeValues,
  fontValues,
  headerValues,
} from "../common/rps/config";
import { alert } from "devextreme/ui/dialog";
import * as utils from "../../common/utils";
import FileUploader from "devextreme-react/file-uploader";
import { getTypeOfFile, onDownloadFile } from "../../common/utils";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import {
  Toolbar,
  HtmlEditor,
  MediaResizing,
  Item,
} from "devextreme-react/html-editor";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import DataGrid, {
  Column,
  Editing,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { confirm } from "devextreme/ui/dialog";
import ACTION_TYPES from "../../actions/actionTypes";
import { Accordion, Item as AccordionItem } from "devextreme-react/accordion";
import Fishbone from "./Fishbone";
import WhyAnalyzer from "./WhyAnalyzer";
import { postUserLog } from "../../actions/common";
import { isEmpty } from "lodash";
import config from "../../common/config"
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialStates = {
  approvers: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: null,
  ophFile: null,
  rpsGridData: null,
};

const RootCauseAnalysis = ({
  siteId,
  activeAlert,
  tierId,
  data,
  activeItem,
  setisOpen,
  rcaStatus,
  setRcaStatus,
  checkSave,
  setCheckSave,
  rootCauseAnalysis,
  setRootCauseAnalysis,
  onHtmlEditorChange,
  onSaveRootCauseWB,
  rpsID,
  handleSPSSave,
  navigationOn,
}) => {
  const [fileName, setFileName] = useState("");
  const [image, setImage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  const [fishBoneData, setFishBoneData] = useState([{}]);
  let {
    approvers,
    ophFile,
    peopleList,
    reasonCodes,
    rpsRail,
    rpsGridData,
    rcaGridData,
    rpsAllData,
    rcaAttachmentData,
  } = state;
  const [isPopupVisible, setIsPopupVisibility] = useState(true);
  const [currEndDate, setCurrEndDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(
    new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  );
  const [completedDate, setCompletedDate] = useState(
    new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  );
  const [processOwner, setProcessOwner] = useState([]);
  const [approver, setApprover] = useState([]);
  const [areaToSolve, setAreaToSolve] = useState([]);
  const [kpiUnit, setKPIUnit] = useState([]);
  const [currentGoal, setCurrentGoal] = useState([]);
  const [currentState, setCurrentState] = useState([]);
  const [doWhat, setDoWhat] = useState([]);
  const [toWhat, setToWhat] = useState([]);
  const [byWhen, setByWhen] = useState(new Date());
  // const [rootCauseAnalysis, setRootCauseAnalysis] = useState('')
  const [initialStateValue, setInitialStateValue] = useState("");
  const [problemToSolve, setProblemToSolve] = useState([]);
  const [reasonForAction, setReasonForAction] = useState([]);
  const [howMuch, setHowMuch] = useState([]);
  const [enableStartDate, setEnableStartDate] = useState(true);
  const [enableByWhen, setEnableByWhen] = useState(true);
  const [enableKPI, setEnableKPI] = useState(true);
  const [enableTargetState, setEnableTargetState] = useState(true);
  const [enableInitialState, setEnableInitialState] = useState(true);
  const initialRPSValue = null;
  let [selectedId, setSelectedId] = useState(null);
  let wbIs, wbRc;
  const wBRc = (k) => {
    wbRc = k;
  };
  const [WBOpen, setWBOpen] = useState(false);
  const [WBRc, setWBRc] = useState(true);
  const refInitialValueState = useRef(null);
  const refRootCauseAnalysis = useRef(null);
  const htmlEditorRef = useRef(null);
  const [addId, setAddId] = useState(2);
  const [dataSource, setDataSource] = useState([
    { causeId: 1, cause: "", rcaid: 0 },
  ]);

  const [theRpsId, setTheRpsId] = useState(rpsID == null ? "" : rpsID);
  const dataGridRef = useRef(null);
  const [htmlContent, setHtmlContent] = useState(
    rpsAllData?.rootCauseAnalysisEditor
  );
  const [enableSave, setEanbleSave] = useState(
    rpsAllData?.status === "Complete"
  );
  const [gridData, setGridData] = useState([
    { causeId: 1, cause: "", rcaid: 0 },
  ]);
  const [enableadd, setenableadd] = useState(true);
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const [editorValue, setEditorValue] = useState("");
  const [whiteBrdData, setwhiteBrdData] = useState(
    JSON.stringify({ objects: [] })
  );
  const [fishBoneDes, setfishBoneDes] = useState("");
  const [topLevelWhys, setTopLevelWhys] = useState([]); // Array to add new branch
  const [whyDescription, setwhyDescription] = useState("");

  useEffect(() => {
    let siteInfo = `&siteId=` + siteId;
    utils.set("wbData_rc", { objects: [] });
    action.fetchUsers(dispatch, "tierId=" + tierId, siteInfo);

    action.fetchRCAGridData(dispatch, theRpsId);

    action.fetchProblemSovingDatabyId(dispatch, theRpsId);

    action.rcaGetAttachmentsData(dispatch, theRpsId, "RootCauseAnalysis");
    AsyncCallHandler(
      NEXUS_CONST.FETCH_SPS_FISHBONE + theRpsId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setFishBoneData(res?.data?.fishbone);
      }
    });
    AsyncCallHandler(
      NEXUS_CONST.FETCH_SPS_FIVEWHY + theRpsId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setTopLevelWhys(res?.data);
      }
    });
  }, []);

  useEffect(() => {
    utils.set(
      "wbData_rc",
      rpsAllData && rpsAllData.rootCauseWhiteBoard
        ? JSON.parse(rpsAllData.rootCauseWhiteBoard)
        : { objects: [] }
    );

    setEanbleSave(rpsAllData?.status === "Complete");
    let defVal = rpsAllData?.rootCauseAnalysisEditor;
    if (
      rpsAllData?.rootCauseAnalysisEditor == null ||
      rpsAllData?.rootCauseAnalysisEditor == undefined
    ) {
      defVal = "";
    } else {
      defVal = rpsAllData?.rootCauseAnalysisEditor;
      var replacedText = defVal
        .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
        .replace(/ /g, "&nbsp;");
    }
    setEditorValue(replacedText);
    setwhiteBrdData(
      rpsAllData && rpsAllData.rootCauseWhiteBoard
        ? JSON.parse(rpsAllData.rootCauseWhiteBoard)
        : { objects: [] }
    );
    setfishBoneDes(rpsAllData?.fishboneDescription);
    setwhyDescription(
      rpsAllData?.rcaProblemStatement !== null
        ? rpsAllData?.rcaProblemStatement
        : ""
    );
  }, [rpsAllData]);

  useEffect(() => {
    setGridData(rcaGridData);
    setenableadd(rcaGridData?.length <= 4 ? true : false);
  }, [rcaGridData]);

  useEffect(() => {
    setPopup(activeAlert);
  }, [activeAlert]);

  const deleteFile = (id) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      if (res) {
        action.deleteRcaFileAttachment(dispatch, id, theRpsId);
      }
    });
  };

  const onFileSelect = (e) => {
    setSelectedFiles(e.value);
    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
    let htmlEditorValue = "";
    if (refRootCauseAnalysis?.current !== null) {
      htmlEditorValue =
        refRootCauseAnalysis?.current?.instance?._options?._optionManager
          ?._options?.value;
      setEditorValue(htmlEditorValue);
    }
  };

  const handleClear = () => {
    setImage(null);
  };

  const setPopup = (activeAlert) => {
    setTitle(activeAlert ? activeAlert.messageTitle : "");
    setDesc(activeAlert ? activeAlert.messageDescription : "");
  };
  const saveSps = () => {
    handleSPSSave();
    setisOpen("4");
  };
  const onRowUpdated = (data) => {
    let input = {
      rcaid: data.data.rcaid ? data.data.rcaid : 0,
      rpsid: data.data.rpsid ? data.data.rpsid : theRpsId,
      causeId: data.data.causeId,
      cause: data.data.cause,
    };
  };
  const onRowInserted = (data) => {
    const numberOfRows =
      dataGridRef.current?.instance?.getVisibleRows()?.length || 0;
    if (numberOfRows <= 4) {
      setenableadd(true);
    } else {
      setenableadd(false);
    }

    let input = {
      rcaid: data.data.rcaid,
      rpsid: theRpsId,
      causeId: data.data.causeId,
      cause: data.data.cause,
    };
  };
  const onInitNewRow = (e) => {
    let maxValue = gridData.reduce((max, obj) => {
      return obj.causeId > max ? obj.causeId : max;
    }, 0);
    e.data.causeId = maxValue + 1;
    e.data.rpsid = theRpsId;
  };
  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowInserted: onRowInserted,
  };
  const onEditorValueChanged = (e) => {
    setEditorValue(e.value);
  };
  const isSubPropertyUnique = (array, subProperty) => {
    const seen = new Set();

    let isUnique = true;
    array.forEach((obj) => {
      obj.subwhys.forEach((subObj) => {
        if (seen.has(subObj[subProperty])) {
          isUnique = false; // Subproperty is not unique
        }
        seen.add(subObj[subProperty]);
      });
    });

    return isUnique;
  };
  const canRCASave = () => {
    let htmlEditorValue = "";
    if (refRootCauseAnalysis?.current !== null) {
      htmlEditorValue =
        refRootCauseAnalysis?.current?.instance?._options?._optionManager
          ?._options?.value;
    } else {
      htmlEditorValue = editorValue;
    }
    let updatedFishBone = fishBoneData?.map((obj) => {
      const filteredFish = obj?.lsCause?.filter((item) => item["value"] !== "");
      return { ...obj, lsCause: filteredFish };
    });
    const fishboneExist = updatedFishBone?.some((obj) => {
      return obj?.lsCause?.length > 0;
    });
    const updatedWhys = topLevelWhys.map((obj) => {
      const filteredSubwhys = obj?.subwhys?.filter(
        (item) => item["whyValue"] !== ""
      );
      return { ...obj, subwhys: filteredSubwhys };
    });
    const whysExists = updatedWhys.some((obj) => {
      return obj?.subwhys?.length > 0;
    });

    const richTextExists =
      htmlEditorValue !== undefined && htmlEditorValue?.length !== 0;

    if (
      (fishboneExist || whysExists || richTextExists) &&
      gridData &&
      gridData?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const saveRPSData = () => {
    let fishbonedataModel = fishBoneData?.forEach((item, index) => {
      item?.lsCause?.forEach((item1, index) => {
        if (typeof item1.id === "string") {
          item1.id = 0;
        }
      });
    });

    let htmlEditorValue = "";
    if (refRootCauseAnalysis?.current !== null) {
      htmlEditorValue =
        refRootCauseAnalysis?.current?.instance?._options?._optionManager
          ?._options?.value;
    } else {
      htmlEditorValue = editorValue;
    }

    let totalFileSize = selectedFiles?.reduce((acc, cur) => {
      return (acc = acc + cur.size);
    }, 0);

    if (!canRCASave()) {
      setEanbleSave(false);
      alert(
        "Please enter at least one record in cause table and fill 5 Why/Fishbone/Rich text editor to save",
        "Alert"
      );
      return false;
    } else {
      if (selectedFiles?.length > 0 && totalFileSize > 4000000) {
        setEanbleSave(false);
        alert(
          "Please make sure attached files size should not exceed 4MB size",
          "Alert"
        );
        return false;
      }

      // Check files are valid or not
      const validateUploadFiles = checkUploadFilesValid(
        selectedFiles,
        ALLOWED_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        setEanbleSave(false);
        return false;
      }

      let updatedWhys = topLevelWhys.map((obj) => {
        const filteredSubwhys = obj?.subwhys?.filter(
          (item) => item["whyValue"] !== ""
        );
        return { ...obj, subwhys: filteredSubwhys };
      });

      const whysExists = updatedWhys.some((obj) => {
        return obj?.subwhys?.length > 0;
      });
      let updatedFishBone = fishBoneData?.map((obj) => {
        const filteredFish = obj?.lsCause?.filter(
          (item) => item["value"] !== ""
        );
        return { ...obj, lsCause: filteredFish };
      });
      const fishBoneExist = updatedFishBone?.some((obj) => {
        return obj?.lsCause?.length > 0;
      });

      if (
        whysExists &&
        (!isSubPropertyUnique(updatedWhys, "whyValue") || whyDescription === "")
      ) {
        setEanbleSave(false);
        alert(
          "Please make sure all why's added are unique and Problem statement field is not empty",
          "Alert"
        );
        return false;
      }

      if (
        fishBoneExist &&
        (fishBoneDes === undefined ||
          fishBoneDes === null ||
          fishBoneDes === "")
      ) {
        setEanbleSave(false);
        alert("Please Fill Fisbone Description", "Alert");
        return false;
      }

      let whydataModel = topLevelWhys?.forEach((item, index) => {
        if (typeof item.id === "string") {
          item.id = 0;
        }
        item?.subwhys?.forEach((item1, index) => {
          if (typeof item1.id === "string") {
            item1.id = 0;
          }
        });
      });

      let rootCauseWB = utils.get("wbData_rc")
        ? JSON.stringify(utils.get("wbData_rc"))
        : { objects: [] };

      let data = {
        rpsid: theRpsId,
        rootCauseAnalysisEditor:
          htmlEditorValue !== undefined ? htmlEditorValue : "",
        rootCauseWhiteBoard: rootCauseWB,
        rcaModel: gridData,
        fishboneModel: fishBoneData,
        fishboneDescription: fishBoneDes,
        why: topLevelWhys.map((obj) => {
          const filteredSubwhys = obj?.subwhys?.filter(
            (item) => item["whyValue"] !== ""
          );
          return { ...obj, subwhys: filteredSubwhys };
        }),
        rcaProblemStatement: whyDescription,
        lastSavedTab: "4",
        section: navigationOn,
        tierId: tierId,
        siteId: siteId,
      };

      AsyncCallHandler(
        NEXUS_CONST.POST_ALL_RCA_DATA,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
          if (selectedFiles?.length === 0) {
            setEanbleSave(false);
          }
          action.fetchProblemSovingDatabyId(dispatch, theRpsId);
          action.fetchRCAGridData(dispatch, theRpsId);
          setwhiteBrdData(
            utils.get("wbData_rc")
              ? JSON.stringify(utils.get("wbData_rc"))
              : { objects: [] }
          );
          saveSps();
          AsyncCallHandler(
            NEXUS_CONST.FETCH_SPS_FISHBONE + theRpsId,
            NEXUS_CONST.GET
          ).then((res) => {
            if (res) {
              setFishBoneData(res?.data?.fishbone);
            }
          });
          AsyncCallHandler(
            NEXUS_CONST.FETCH_SPS_FIVEWHY + theRpsId,
            NEXUS_CONST.GET
          ).then((res) => {
            if (res) {
              setTopLevelWhys(res?.data);
            }
          });
        }
      });

      if (selectedFiles?.length > 0) {
        let formData = new FormData();
        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append("rpsId", theRpsId ? theRpsId : 0);
        formData.append("attachmentType", "RootCauseAnalysis");
        formData.append("section", navigationOn);
        formData.append("tierID", tierId);
        AsyncCallHandler(
          NEXUS_CONST.RCA_ATTACHMENT,
          NEXUS_CONST.PUT,
          formData
        ).then((res) => {
          setEanbleSave(false);

          dispatch({
            type: ACTION_TYPES.RCA_ATTACHMENT,
            payload: res.data,
          });

          action.rcaGetAttachmentsData(dispatch, theRpsId, "RootCauseAnalysis");
          setSelectedFiles([]);
        });
      }
    }
  };

  const submitRPS = () => {
    let result = null;
    dataGridRef.current?.instance?.saveEditData();
    setEanbleSave(true);

    if (rpsAllData?.vsTabs[4].isSaved === false && gridData.length > 0) {
      result = confirm(
        "Note : The root causes added in the table can no longer be deleted",
        "Are you sure you want proceed?"
      );
      result.then((res) => {
        if (res) {
          if (!canRCASave()) {
            setEanbleSave(false);
            alert(
              "Please enter at least one record in cause table and fill 5 Why/Fishbone/Rich text editor to save",
              "Alert"
            );
            return false;
          } else {
            saveRPSData();
          }
        } else {
          setEanbleSave(false);
        }
      });
    } else {
      saveRPSData();
    }
  };
  let defVal = rpsAllData?.rootCauseAnalysisEditor;
  if (
    rpsAllData?.rootCauseAnalysisEditor == null ||
    rpsAllData?.rootCauseAnalysisEditor == undefined
  ) {
    defVal = "";
  } else {
    defVal = rpsAllData?.rootCauseAnalysisEditor;
    var replacedText = defVal
      .replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
      .replace(/ /g, "&nbsp;");
  }
  const handleDataFromFishBone = (data) => {
    setFishBoneData(data);
  };

  const accordionDataInitial = [
    {
      title: "5 Why",

      content: (
        <div>
          <WhyAnalyzer
            topLevelWhys={topLevelWhys}
            setTopLevelWhys={setTopLevelWhys}
            whyDescription={whyDescription}
            setwhyDescription={setwhyDescription}
          />
        </div>
      ),
    },
    {
      title: "Fishbone",

      content: (
        <div>
          <Fishbone
            theRpsId={theRpsId}
            fishBoneData={fishBoneData}
            setFishBoneData={setFishBoneData}
            fishBoneDes={fishBoneDes}
            setfishBoneDes={setfishBoneDes}
          />
        </div>
      ),
    },

    {
      title: "Rich Text Editor",
      content: (
        <div>
          {(() => {
            if (theRpsId && rpsAllData?.rootCauseAnalysisEditor == null) {
              return (
                <div className="editor">
                  <HtmlEditor
                    ref={refRootCauseAnalysis}
                    height={300}
                    valueType="html"
                    allowfullscreen={true}
                    defaultValue={""}
                  >
                    <MediaResizing enabled={true} />
                    <Toolbar multiline={true}>
                      <Item name="undo" />
                      <Item name="redo" />
                      <Item name="separator" />
                      <Item name="size" acceptedValues={sizeValues} />
                      <Item name="font" acceptedValues={fontValues} />
                      <Item name="separator" />
                      <Item name="bold" />
                      <Item name="italic" />
                      <Item name="strike" />
                      <Item name="underline" />
                      <Item name="separator" />
                      <Item name="alignLeft" />
                      <Item name="alignCenter" />
                      <Item name="alignRight" />
                      <Item name="alignJustify" />
                      <Item name="separator" />
                      <Item name="orderedList" />
                      <Item name="bulletList" />
                      <Item name="separator" />
                      <Item name="header" acceptedValues={headerValues} />
                      <Item name="separator" />
                      <Item name="color" />
                      <Item name="background" />
                      <Item name="separator" />
                      <Item name="link" />
                      <Item name="separator" />
                      <Item name="clear" />
                      <Item name="separator" />
                    </Toolbar>
                  </HtmlEditor>
                </div>
              );
            } else if (
              theRpsId &&
              rpsAllData?.rootCauseAnalysisEditor !== null
            ) {
              return (
                <HtmlEditor
                  ref={refRootCauseAnalysis}
                  height={300}
                  valueType="html"
                  allowfullscreen={true}
                  defaultValue={
                    defVal == "null" || defVal == "" ? "" : replacedText
                  }
                >
                  <MediaResizing enabled={true} />
                  <Toolbar multiline={true}>
                    <Item name="undo" />
                    <Item name="redo" />
                    <Item name="separator" />
                    <Item name="size" acceptedValues={sizeValues} />
                    <Item name="font" acceptedValues={fontValues} />
                    <Item name="separator" />
                    <Item name="bold" />
                    <Item name="italic" />
                    <Item name="strike" />
                    <Item name="underline" />
                    <Item name="separator" />
                    <Item name="alignLeft" />
                    <Item name="alignCenter" />
                    <Item name="alignRight" />
                    <Item name="alignJustify" />
                    <Item name="separator" />
                    <Item name="orderedList" />
                    <Item name="bulletList" />
                    <Item name="separator" />
                    <Item name="header" acceptedValues={headerValues} />
                    <Item name="separator" />
                    <Item name="color" />
                    <Item name="background" />
                    <Item name="separator" />
                    <Item name="link" />
                    <Item name="separator" />
                    <Item name="clear" />
                    <Item name="separator" />
                  </Toolbar>
                </HtmlEditor>
              );
            }
          })()}
        </div>
      ),
    },

    {
      title: "White Board",

      content: (
        // <>
        //   {WBRc && (
        <div>
          <WhiteBoard
            siteId={siteId}
            isRps={true}
            wbRef={wBRc}
            rpsData={whiteBrdData}
            widgetId={"rc"}
          />
        </div>
        //   )}
        // </>
      ),
    },
  ];
  // as we have functions usage in this variable moving this const down
  const accordionData = config.DEV_DISPLAY_OPTIONS ? accordionDataInitial : accordionDataInitial.slice(0, accordionDataInitial.length-1);

  const onItemClick = (e) => {
    const clickedElement = e.event.target;
    const clickedIndex = e.itemIndex;
    let rootCauseWB = utils.get("wbData_rc")
      ? JSON.stringify(utils.get("wbData_rc"))
      : { objects: [] };

    setwhiteBrdData(
      utils.get("wbData_rc")
        ? JSON.stringify(utils.get("wbData_rc"))
        : { objects: [] }
    );
    const clsLst = [
      "dx-accordion-item-title",
      "dx-accordion-item-title-caption",
    ];
    // Check if the clicked element has a class or property that identifies it as the title element.
    const isTitleClicked =
      clickedElement.classList.contains("dx-accordion-item-title") ||
      clickedElement.classList.contains("dx-accordion-item-title-caption");

    let richtextValue =
      refRootCauseAnalysis?.current?.instance?._options?._optionManager
        ?._options?.value;

    if (richtextValue !== undefined && richtextValue !== null) {
      setEditorValue(richtextValue);
    }

    if (isTitleClicked) {
      if (clickedIndex === 1) {
        setWBRc(!WBRc);
      }
      // Check if the clicked section is already open
      if (selectedIndexes.includes(clickedIndex)) {
        // If the clicked section is already open, do nothing

        setSelectedIndexes([]);
      } else {
        // If the clicked section is closed, open it and close others
        setSelectedIndexes([clickedIndex]);

        if (clickedIndex === 0) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `5 Why selected for PS-${rpsID}`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }

        if (clickedIndex === 1) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `Fishbone selected for PS-${rpsID}`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }
        if (clickedIndex === 2) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `Rich Text Editor selected for PS-${rpsID}`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }

        // If white board is selected log the info to userLogs -> white board accordion index is 3
        if (clickedIndex === 3) {
          postUserLog({
            event: `Box 4 - Root Cause Analysis`,
            data: {
              action: `Whiteboard selected for PS-${rpsID}`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }
      }
    }
  };

  const onApprover = (e) => {
    setApprover(e.value);
    setEnableStartDate(false);
  };
  const onOphFile = () => {
    action.downloadOphFile(
      ophFile.file,
      "digitaltier/DownloadExcelFile?filename=" + ophFile.file
    );
  };
  const onKPIChange = (e) => {
    setKPIUnit(e.value);
  };

  const onProblemToSolve = (e) => {
    setProblemToSolve(e.value);
    setEnableKPI(false);
  };

  const cellRenderColor = (cell) => {
    return (
      <div
        style={{
          width: "20%",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: cell.data.colorcode
            ? cell.data.colorcode
            : "#FFFFFF",
        }}
      ></div>
    );
  };
  const onSetHowMuch = (e) => {
    setHowMuch(e.value);
    setEnableByWhen(false);
  };
  const wBIs = (k) => {
    wbIs = k;
  };
  const onByWhenDateChange = (e) => {
    setByWhen(e.value);
    onDueDateChange(e);
  };

  const onDueDateChange = (e) => {
    setDueDate(e.value);
  };

  const onCurrentStateChanged = (e) => {
    setCurrentState(e.value);
    setEnableInitialState(false);
  };

  const onInitialValueChange = (e) => {
    setEnableTargetState(false);
  };

  const handleSave = () => {
    let rootCauseWB = utils.get("wbData_rc")
      ? JSON.stringify(utils.get("wbData_rc"))
      : "";

    setRootCauseAnalysis(
      refRootCauseAnalysis.current.instance._options._optionManager._options
        .value
    );

    let htmlEditor =
      refRootCauseAnalysis.current.instance._options._optionManager._options
        .value;

    let htmlEditor2 = htmlEditorRef?.current?.instance?.option("value");
  };

  rcaGridData && rcaGridData.sort((a, b) => a.causeId - b.causeId);

  const handleWhiteBoard = () => {
    setWBRc(!WBRc);
  };
  const [openItemIndex, setOpenItemIndex] = useState(-1);

  const handleAccordionItemClick = (index) => {
    // Toggle the open/close state of the clicked item
    if (index === openItemIndex) {
      setOpenItemIndex(-1); // Clicking on the opened item closes it
    } else {
      setOpenItemIndex(index); // Clicking on a different item opens it
    }
  };
  return (
    <>
      <div>
        <div className="title-section">
          {" "}
          <h2 className="sps_title">
            <span className="sps-print">Box 4 - &nbsp;</span>Root Cause Analysis
          </h2>{" "}
          <div className="sps-save-btn save-btn">
            <Button
              style={{ float: "right", width: "140px", "margin-top": "3%" }}
              disabled={enableSave}
              width={200}
              onClick={submitRPS}
              text="Save"
              type="normal"
            />
          </div>
        </div>
        <ScrollView width="100%" height="420px" className="sps-box-s">
          <Accordion
            width="98.5%"
            multiple={false}
            animationDuration={300}
            onItemClick={onItemClick}
            collapsible={true}
            // selectedIndex={selectedIndexes}
          >
            {accordionData.map((item, index) => (
              <AccordionItem
                key={index}
                title={item.title}
                // expanded={index === openItemIndex}
                // onTitleClick={(e) => handleAccordionItemClick(index)}
              >
                {item.content}
              </AccordionItem>
            ))}
          </Accordion>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="datagrid-machine rca">
              <DataGrid
                style={{ paddingTop: "10px", paddingRight: "20px" }}
                ref={dataGridRef}
                dataSource={gridData}
                allowColumnReordering={true}
                showBorders={true}
                {...CONFIG.RPS_EXPERIMENT}
                onInitNewRow={onInitNewRow}
                {...handlers}
                wordWrapEnabled={true}
                width={"100%"}
                onExporting={() =>
                  postUserLog({
                    event: `Box 4 - Root Cause Analysis Export`,
                    data: {
                      action: `Root Cause Analysis exported for PS-${rpsID}`,
                      module: "Digital Tier",
                      section: navigationOn,
                      siteUId: siteId,
                      widget: "Structured Problem Solving",
                      tierId,
                    },
                  })
                }
                onToolbarPreparing={function (e) {
                  var dataGrid = e.component;
                  var toolbarItems = e.toolbarOptions.items;
                  // Adds a new item
                  toolbarItems.unshift(
                    {
                      location: "before",
                      template: "",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        hint: "Refresh",
                        onClick: function () {
                          dataGrid.refresh();
                          postUserLog({
                            event: `Box 4 - Root Cause Analysis Refreshed`,
                            data: {
                              action: `Root Cause Analysis refreshed for PS-${rpsID}`,
                              module: "Digital Tier",
                              section: navigationOn,
                              siteUId: siteId,
                              widget: "Structured Problem Solving",
                              tierId,
                            },
                          });
                        },
                      },
                    }
                  );
                }}
              >
                <Paging enabled={false} />
                <SearchPanel
                  visible={true}
                  onTextChange={(e) => {
                    if (!isEmpty(e)) {
                      postUserLog({
                        event: "Box 4 - Root Cause Analysis Grid Search",
                        data: {
                          action: `${e} searched in root cause analysis grid for PS-${rpsID}`,
                          module: "Digital Tier",
                          section: navigationOn,
                          siteUId: siteId,
                          widget: "Structured Problem Solving",
                          tierId: tierId,
                        },
                      });
                    }
                  }}
                />
                <Editing
                  mode="cell"
                  allowUpdating={true}
                  allowAdding={enableadd}
                  allowDeleting={
                    rpsAllData?.vsTabs[4].isSaved === true ? false : true
                  }
                  useIcons={
                    rpsAllData?.vsTabs[4].isSaved === true ? false : true
                  }
                />
                <Column
                  dataField="causeId"
                  caption="Cause#"
                  allowFiltering={false}
                  allowEditing={false}
                  minWidth={20}
                />
                <Column
                  dataField="cause"
                  caption="Root Cause(s)(Description)"
                  allowFiltering={false}
                  cssClass="WrappedColumn"
                  width={900}
                  minWidth={20}
                >
                  <RequiredRule />
                </Column>
                <Column
                  dataField="rcaid"
                  caption="rcaid"
                  visible={false}
                  minWidth={20}
                ></Column>
              </DataGrid>
              <p></p>
            </div>
          </div>

          <div className="dx-field gridavailable"></div>
          <div
            style={{ display: "flex", flexDirection: "column" }}
            className="no-print"
          >
            <div className="dx-field-labelatc">
              {" "}
              Root Cause Analysis Attachment{" "}
            </div>
            {activeAlert?.imageName && (
              <div>
                <a
                  style={{ cursor: "pointer" }}
                  className="clickable-hover"
                  onClick={() => {
                    getTypeOfFile(
                      {
                        imageName: activeAlert.imageName,
                        fileExtension: activeAlert?.imageName.split(".")[1],
                      },
                      "Sites"
                    );
                  }}
                >
                  {" "}
                  {activeAlert?.imageName}
                </a>
                &nbsp; &nbsp;&nbsp;
                {(activeAlert.imageName != "DELETED" || "") && (
                  <>
                    {" "}
                    <i
                      title="Delete"
                      className="fas fa-trash pointer"
                      onClick={() => deleteFile()}
                    ></i>
                    &nbsp; &nbsp;&nbsp;
                    <i
                      title="Download"
                      className="fa fa-download pointer"
                      onClick={() =>
                        onDownloadFile(activeAlert?.imageName, "Sites")
                      }
                    ></i>
                  </>
                )}
              </div>
            )}
            {(!activeAlert?.imageName ||
              activeAlert?.imageName == "DELETED" ||
              "") && (
              <FileUploader
                className="dx-field-value gridavailable"
                selectButtonText="Choose file"
                labelText="Max. File Size 4 MB"
                accept="*"
                uploadMode="uploadUrl"
                multiple={true}
                onValueChanged={onFileSelect}
                value={selectedFiles}
                allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
              />
            )}
            <div>
              {rcaAttachmentData &&
                rcaAttachmentData.map((item) => (
                  <div>
                    <a
                      style={{ cursor: "pointer" }}
                      className="clickable-hover"
                      onClick={() => {
                        getTypeOfFile(
                          {
                            imageName: item?.attachmentName,
                            folderName: "RPS",
                            subfolderName: "RootCauseAnalysis",
                            fileExtension: "xls",
                          },
                          "RPS"
                        );
                      }}
                    >
                      {" "}
                      {item?.attachmentName}{" "}
                    </a>
                    <span className="rca_download">
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        onClick={() =>
                          onDownloadFile(
                            item?.attachmentName,
                            "RPS",
                            "RootCauseAnalysis"
                          )
                        }
                      ></i>
                    </span>
                    <span
                      className="rca_delete"
                      style={{ padding: "0px 15px 0px 10px" }}
                    >
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={() => deleteFile(item.id)}
                      ></i>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </ScrollView>
      </div>
    </>
  );
};

export default RootCauseAnalysis;
